(function() {
  exports.geocode = function(address, zoom) {
    if (zoom == null) {
      zoom = 16;
    }
    return $.post('backend/geocode', {
      address: address
    }, function(result) {
      var coords;
      result = $.parseJSON(result);
      if (result.success || result.success === 'true') {
        coords = [result.lat, result.lng];
        if (coords != null) {
          App.map.setView(coords, zoom);
        }
      }
      return result;
    });
  };

}).call(this);
